import { detectIncognito } from 'detectincognitojs'

let isNotSupported: Promise<boolean> | undefined

export const isPartytownNotSupported = async () => {
	if (isNotSupported !== undefined) {
		return isNotSupported
	}
	isNotSupported = new Promise(async (resolve) => {
		try {
			const { isPrivate, browserName } = await detectIncognito()
			resolve(['Firefox', 'Chrome'].includes(browserName) ? isPrivate : false)
		} catch (e) {
			// detectIncognito throws an error when it fails to recognize the browser.
			resolve(false)
		}
	})
	return isNotSupported
}
